export function initYandexMetrika() {
    if (typeof window === 'undefined') return;

    try {
        (function (m, e, t, r, i, k, a) {
            m[i] = m[i] || function () {
                (m[i].a = m[i].a || []).push(arguments);
            };
            m[i].l = 1 * new Date();
            for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) {
                    return;
                }
            }
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
        })
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        window.ym(87205311, "init", {
            defer: false,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            trackHash: true,
            ecommerce: false,
            trustedDomains: [],
            childIframe: false,
            ut: "noindex",
            userParams: {},
            triggerEvent: true,
            w_use_settings: true,
            publisher: true,
        });

        window.ym(99984857, "init", {
            defer: false,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            trackHash: true,
            ecommerce: false,
            trustedDomains: [],
            childIframe: false,
            ut: "noindex",
            userParams: {},
            triggerEvent: true,
            w_use_settings: true,
            publisher: true,
        });
        
        console.log('Yandex.Metrika initialized with webvisor enabled');
    } catch (e) {
        console.error('Error initializing Yandex.Metrika:', e);
    }
}

export function trackPageView(event) {
    if (typeof window === 'undefined') return;
    
    if (typeof window.ym === 'undefined') {
        console.error('Yandex.Metrika not initialized yet');
        return;
    }

    try {
        const page = event.detail.page;
        const props = page.props;

        const metrikaParams = {
            referer: event.detail.page.url !== window.location.pathname ? event.detail.page.url : document.referrer,
            title: document.title
        };

        if (props.element && page.component.includes('Articles/ArticleShow')) {
            if (props.element.views) {
                metrikaParams.viewCount = props.element.views;
            }

            if (props.text && props.text.duration) {
                metrikaParams.readingTime = props.text.duration;
            }
        }

        window.ym(87205311, 'hit', window.location.pathname, metrikaParams);
        window.ym(99984857, 'hit', window.location.pathname, metrikaParams);
        
        console.log('Page view tracked in Yandex.Metrika');
    } catch (error) {
        console.error('Error sending data to Yandex.Metrika:', error);
    }
}
